import { ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, LoadProducts } from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/LoadProductsToCompare";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { replaceInChain } from "@ucs/Store/CustomHandlerCreator";

interface Parameter {
    id: string;
    productIds: string[];
    includeAttributeTypes?: boolean;
}
type HandlerType = ApiHandlerDiscreteParameter<Parameter, GetProductCollectionApiV2Parameter>;

export const LoadProductsWithForceReload: HandlerType = props => {
    props.dispatch(
        loadProductInfoList({
            id: props.parameter.id,
            getProductCollectionParameter: props.apiParameter,
            forceLoad: true,
        }),
    );
};

replaceInChain(chain, LoadProducts, LoadProductsWithForceReload);
